import React from 'react';
import { MenuItem } from '@material-ui/core';
import { OptionProps } from 'react-select/src/components/Option';
import { OptionTypeBase } from 'react-select/src/types';

export const Option = (props: OptionProps<OptionTypeBase, boolean>) => (
  <MenuItem
    ref={props.innerRef}
    selected={props.isFocused}
    component="div"
    className={props.selectProps.classes.manuItem}
    style={{
      fontWeight: props.isSelected ? 500 : 400,
    }}
    {...props.innerProps}
  >
    {props.children}
  </MenuItem>
);
